module.exports = __webpack_public_path__ + "static/media/5.14.5297c33b.png";